export * from "./common";
export const generateExternalBuyUrl = url => url;
